import FooterComponent from "../components/FooterComponent"

const Footer = () => {
  return (
    <FooterComponent />
  )
}

export default Footer